export default __webpack_public_path__ + "static/media/figma-1.72ff3502.svg";